import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import EcrionFrame from '../../../../frame/FrameBase';
import { Typography } from '@material-ui/core';
import PageCommon from '../../../../page/Common';
import Extensions from '../../../../apps/Extensions';
import Modals from '../../../../modal';
import BlockPrompt from '../../../../form/BlockPrompt';
import crossDocumentProtocol from '../../../../frame/FrameBase/crossDocumentProtocol';
import getFileExtension from '../../../../utils/pathUtil/getFileExtension';
import encodePathForUri from '../../../../utils/pathUtil/encodePathForUri';
import encodePathForUriComponent from '../../../../utils/pathUtil/encodePathForUriComponent';
import stripDesignTrunkFromPath from '../../../../utils/pathUtil/stripDesignTrunkFromPath';
import stringifySearchParams from '../../../../utils/url/stringifySearchParams';

var getEncodedFilePath = function getEncodedFilePath(workspace, path, isUri) {
  var fixedPath = stripDesignTrunkFromPath(path);
  if (isUri) return "".concat(encodeURI(workspace), "/").concat(encodePathForUri(fixedPath));
  return "".concat(encodeURIComponent(workspace), "/").concat(encodePathForUriComponent(fixedPath));
};

var getUrl = function getUrl(_ref) {
  var workspace = _ref.workspace,
      path = _ref.path,
      mode = _ref.mode,
      customParameters = _ref.customParameters,
      canChangeDataSource = _ref.canChangeDataSource;
  var route = null;
  var queryString = stringifySearchParams({
    returnUrl: 'message-close-editor',
    canChangeDataSource: canChangeDataSource,
    mode: mode
  }, {});

  switch (getFileExtension(path)) {
    case 'epr':
    case 'epb':
      route = "embed/EprEditor?".concat(queryString, "#workspace/").concat(getEncodedFilePath(workspace, path));
      break;

    case 'efd':
      route = "embed/FormEditor?".concat(queryString, "#workspace/").concat(getEncodedFilePath(workspace, path));
      break;

    case 'ehtml':
      route = "embed/EmailEditor/".concat(getEncodedFilePath(workspace, path, true), "?").concat(queryString);
      break;

    default:
      break;
  }

  if (customParameters && customParameters.length > 0) {
    // add origin to be a valid URL
    var url = new URL(route, 'https://ecrion.com');

    for (var i = 0; i < customParameters.length; i++) {
      url.searchParams.append(customParameters[i].name, customParameters[i].value);
    } // compute route without origin


    route = url.pathname + url.search + url.hash; // remove first '/' from route

    route = route.substring(1);
  }

  return route;
};

var getMessageNamespace = function getMessageNamespace(ext) {
  var namespace = '';

  switch (ext) {
    case 'epr':
    case 'epb':
      namespace = 'EprEditor';
      break;

    case 'efd':
      namespace = 'FormEditor';
      break;

    case 'ehtml':
      namespace = 'EmailEditor';
      break;

    default:
      break;
  }

  return namespace;
};
/**
 * @extends {React.Component<import('./types').FileEditorFrameProps>}
 */


var FileEditorFrame =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FileEditorFrame, _React$Component);

  function FileEditorFrame(props) {
    var _this;

    _classCallCheck(this, FileEditorFrame);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FileEditorFrame).call(this, props));
    _this.state = {
      dirty: false,
      modified: false,
      leaveConfirmationOpen: false
    };
    return _this;
  }

  _createClass(FileEditorFrame, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var namespace = getMessageNamespace(getFileExtension(this.props.path));
      crossDocumentProtocol.on('close-editor', this.handleClose.bind(this));
      crossDocumentProtocol.on(namespace, function (eventName, eventData) {
        var action = eventName.substring(namespace.length + 1);

        switch (action) {
          case 'Pristine':
            _this2.setState(function (currentState) {
              return {
                dirty: false,
                modified: currentState.dirty === true
              };
            });

            break;

          case 'Dirty':
            _this2.setState({
              dirty: true
            });

            break;

          default:
            _this2.props.onEvent && _this2.props.onEvent(action, eventData);
            break;
        }
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var namespace = getMessageNamespace(getFileExtension(this.props.path));
      crossDocumentProtocol.off('close-editor', this.handleClose.bind(this));
      crossDocumentProtocol.off(namespace);
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      var _this3 = this;

      var onClose = this.props.onClose;

      if (onClose) {
        if (this.state.dirty) {
          this.setState({
            leaveConfirmationOpen: true
          });
          Modals.open({
            type: Modals.TYPES.CONFIRMATION,
            props: {
              title: 'Leave page',
              message: 'You have unsaved changes. Are you sure you want to leave this page?',
              onConfirm: function onConfirm() {
                // set dirty to false to remove native confirmation prompt
                _this3.setState({
                  dirty: false
                });

                onClose(false);
              },
              onClose: function onClose() {
                _this3.setState({
                  leaveConfirmationOpen: false
                });
              }
            }
          });
        } else {
          onClose(this.state.modified);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          workspace = _this$props.workspace,
          path = _this$props.path,
          canChangeDataSource = _this$props.canChangeDataSource,
          mode = _this$props.mode,
          customParameters = _this$props.customParameters;
      var url = getUrl({
        workspace: workspace,
        path: path,
        canChangeDataSource: canChangeDataSource,
        mode: mode,
        customParameters: customParameters
      });
      return React.createElement(PageCommon, {
        margin: "none",
        copyright: false,
        style: {
          overflowY: 'hidden'
        }
      }, React.createElement(BlockPrompt, {
        when: this.state.dirty && !this.state.leaveConfirmationOpen
      }), !url && React.createElement(Typography, {
        color: "error"
      }, "This type of file can't be edited."), url && React.createElement(EcrionFrame, {
        useEcrionServer: true,
        url: url,
        height: "100vh"
      }));
    }
  }]);

  return FileEditorFrame;
}(React.Component);

FileEditorFrame.defaultProps = {
  mode: 'basic',
  customParameters: [],
  canChangeDataSource: false
};
export default FileEditorFrame;